import { EbActionIcon } from "../shared/components/EbActionItem";
import { IconCopy } from "../shared/components/Icons";
import { Button, Flex, Paper, Text, TableData, Table } from "@mantine/core";
import { EbTooltip } from "../shared/components/EbTooltip";

interface Props {
  ventId: string;
  onClose: () => void;
}
const ShowMacros = (props: Props) => {
  const tableData: TableData = {
    caption: "Copy a macro and paste it into the body of the email template",
    head: ["Copy", "Macro", "Example", "Description"],
    body: [
      [
        <EbActionIcon
          aria-label="Copy macro"
          onClick={async () => {
            await navigator.clipboard.writeText("{{EVENT_NAME}}");
          }}
        >
          <EbTooltip label="Copy macro">
            <IconCopy />
          </EbTooltip>
        </EbActionIcon>,
        "{{EVENT_NAME}}",
        "Graduation Picnic",
        "Name of the event",
      ],
      [
        <EbActionIcon
          aria-label="Copy macro"
          onClick={async () => {
            await navigator.clipboard.writeText("{{PERSONAL_EVENT_LINK}}");
          }}
        >
          <EbTooltip label="Copy macro">
            <IconCopy />
          </EbTooltip>
        </EbActionIcon>,
        "{{PERSONAL_EVENT_LINK}}",
        "http://app.earlybirdrsvp.com/pel/...",
        "Personal event link for the guest",
      ],
      [
        <EbActionIcon
          aria-label="Copy macro"
          onClick={async () => {
            await navigator.clipboard.writeText("{{EVENT_LINK}}");
          }}
        >
          <EbTooltip label="Copy macro">
            <IconCopy />
          </EbTooltip>
        </EbActionIcon>,
        "{{EVENT_LINK}}",
        "http://app.earlybirdrsvp.com/...",
        "Link to the event home page",
      ],
      [
        <EbActionIcon
          aria-label="Copy macro"
          onClick={async () => {
            await navigator.clipboard.writeText("{{EVENT_LOCATION_URL}}");
          }}
        >
          <EbTooltip label="Copy macro">
            <IconCopy />
          </EbTooltip>
        </EbActionIcon>,
        "{{EVENT_LOCATION_URL}}",
        "http://app.earlybirdrsvp.com...",
        "Event's location URL",
      ],
      [
        <EbActionIcon
          aria-label="Copy macro"
          onClick={async () => {
            await navigator.clipboard.writeText("{{EVENT_LOCATION}}");
          }}
        >
          <EbTooltip label="Copy macro">
            <IconCopy />
          </EbTooltip>
        </EbActionIcon>,
        "{{EVENT_LOCATION}}",
        "123 Main St. Springfield, IL",
        "Event's location text",
      ],
      [
        <EbActionIcon
          aria-label="Copy macro"
          onClick={async () => {
            await navigator.clipboard.writeText("{{EVENT_STARTS}}");
          }}
        >
          <EbTooltip label="Copy macro">
            <IconCopy />
          </EbTooltip>
        </EbActionIcon>,
        "{{EVENT_STARTS}}",
        "Friday, Jun 06, 2025 5:00 PM EDT",
        "Event start date and time",
      ],
      [
        <EbActionIcon
          aria-label="Copy macro"
          onClick={async () => {
            await navigator.clipboard.writeText("{{RSVP_ENDS}}");
          }}
        >
          <EbTooltip label="Copy macro">
            <IconCopy />
          </EbTooltip>
        </EbActionIcon>,
        "{{RSVP_ENDS}}",
        "Monday, Jun 02, 2025 11:59 PM EDT",
        "RSVP end date and time",
      ],
      [
        <EbActionIcon
          aria-label="Copy macro"
          onClick={async () => {
            await navigator.clipboard.writeText("{{FIRST_NAME}}");
          }}
        >
          <EbTooltip label="Copy macro">
            <IconCopy />
          </EbTooltip>
        </EbActionIcon>,
        "{{FIRST_NAME}}",
        "Robin",
        "Guest's first name",
      ],
      [
        <EbActionIcon
          aria-label="Copy macro"
          onClick={async () => {
            await navigator.clipboard.writeText("{{LAST_NAME}}");
          }}
        >
          <EbTooltip label="Copy macro">
            <IconCopy />
          </EbTooltip>
        </EbActionIcon>,
        "{{LAST_NAME}}",
        "Redbreast",
        "Guest's last name",
      ],
      [
        <EbActionIcon
          aria-label="Copy macro"
          onClick={async () => {
            await navigator.clipboard.writeText("{{FAMILY_GREETING}}");
          }}
        >
          <EbTooltip label="Copy macro">
            <IconCopy />
          </EbTooltip>
        </EbActionIcon>,
        "{{FAMILY_GREETING}}",
        "Kevin and family",
        "Greeting for the guest's family, defaults to first name",
      ],
      [
        <EbActionIcon
          aria-label="Copy macro"
          onClick={async () => {
            await navigator.clipboard.writeText("{{OWNER_NAME}}");
          }}
        >
          <EbTooltip label="Copy macro">
            <IconCopy />
          </EbTooltip>
        </EbActionIcon>,
        "{{OWNER_NAME}}",
        "Robin Redbreast",
        "Owner's full name",
      ],
      [
        <EbActionIcon
          aria-label="Copy macro"
          onClick={async () => {
            await navigator.clipboard.writeText("{{OWNER_FIRST_NAME}}");
          }}
        >
          <EbTooltip label="Copy macro">
            <IconCopy />
          </EbTooltip>
        </EbActionIcon>,
        "{{OWNER_FIRST_NAME}}",
        "Robin",
        "Owner's first name",
      ],
      [
        <EbActionIcon
          aria-label="Copy macro"
          onClick={async () => {
            await navigator.clipboard.writeText("{{OWNER_EMAIL}}");
          }}
        >
          <EbTooltip label="Copy macro">
            <IconCopy />
          </EbTooltip>
        </EbActionIcon>,
        "{{OWNER_EMAIL}}",
        "owner@example.com",
        "Owner's email address",
      ],
    ],
  };

  return (
    <>
      <Paper>
        <Text size="lg">Email Template Macros</Text>
        <Table data={tableData} />
        <Flex justify="flex-end">
          <Button mt="md" mr="md" onClick={props.onClose}>
            Close
          </Button>
        </Flex>
      </Paper>
    </>
  );
};

export default ShowMacros;
